import { alpha, Button, styled } from "@mui/material";
import { Form } from "formik";
import FormikAutocomplete from "../commons/formik/FormikAutocomplete";

export const StyledEmpleador = {
    Form: styled(Form)(({ theme }) => ({
        display: "flex",
        flexDirection: "column",
        gap: "1vh",
        width: "100%",
        paddingTop: "20px",
    })),
    InputLabel: styled(FormikAutocomplete)(({ theme }) => ({
        width: "100%",
        "& label": {
            fontSize: 17.3,
            fontWeight: 600,
        },
    })),
    LogoutButton: styled(Button)(({ theme }) => ({
        marginRight: '5px',
        backgroundColor: alpha(theme.palette.primary.menuItem, 0.15),
        "&:hover": {
            backgroundColor: alpha(theme.palette.primary.menuItem, 0.3)
        }
    })),
    LoginButton: styled(Button)(({ theme }) => ({
        width: '77%',
        backgroundColor: theme.palette.tertiary.main,
    })),
    ButtonsContainer: styled('div')(({ theme }) => ({
        marginTop: "15px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
    })),
}